import { authHeader } from '@/utils';
import axios from 'axios';

/* URL API */
//produccion --> https://prod-api-estudiantes-externos.utic.ecosur.mx/
//desarrollo --> https://dev-api-estudiantes-externos.utic.ecosur.mx/

const jsonClient = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: authHeader(),
  },
});

export default jsonClient;
